import moment from 'moment';
import { useIntl } from 'react-intl';

import './duration.scss';

export function Duration({ ad, creative }: { ad: any; creative: any }) {
  const { formatMessage } = useIntl();
  const isRedirect = creative?.redirect;
  const rawDuration = isRedirect
    ? ad.adOptions?.vastWrapperAttr?.attributes?.duration
    : creative?.vastOptions?.creative?.attributes?.duration;

  const duration = ['vast', 'dast'].includes(creative?.type)
    ? Boolean(rawDuration) && !['', '00:00:000', '00:00:00'].includes(rawDuration)
      ? moment(rawDuration, 'mm:ss:SSS').format('mm:ss:SSS')
      : formatMessage({
          defaultMessage: 'No Apply',
          id: 'multiflight.creatives.duration.noApply'
        })
    : formatMessage({
        defaultMessage: 'No Apply',
        id: 'multiflight.creatives.duration.noDuration'
      });

  return <div className="duration">{duration}</div>;
}
